import React from 'react';
import user5 from '../images/dashboard/user5.jpg';
import user3 from '../images/dashboard/user3.jpg';
import user1 from '../images/dashboard/user1.jpg';
import boy2 from '../images/dashboard/boy-2.png';
import designer from '../images/dashboard/designer.jpg';
import user from '../images/dashboard/user.png'

export const data = [
    {
        id:"1",
        avtar: <img src={user5} style={{ width: 50, height: 50 }} />,
        f_name: "Rowan",
        l_name: "Torres",
        email: "Rowan.torres@gmail.com",
        last_login: "6 Days ago",
        role: "Customer"
    },
    {
        id: "2",
        avtar: <img src={user3} style={{ width: 50, height: 50 }} />,
        f_name: "Alonzo",
        l_name: "Perez",
        email: "Perez.Alonzo@gmail.com",
        last_login: "2 Days ago",
        role: "Customer"
    },
    {
        id: "3",
        avtar: <img src={user1} style={{ width: 50, height: 50 }} />,
        f_name: "Skylar",
        l_name: "Lane",
        email: "Lane.Skylar@gmail.com",
        last_login: "1 Days ago",
        role: "Customer"
    },
    {
        id: "4",
        avtar: <img src={boy2} style={{ width: 50, height: 50 }} />,
        f_name: "Brody",
        l_name: "Gray",
        email: "Gray.Brody@gmail.com",
        last_login: "3 Days ago",
        role: "Admin"
    },
    {
        id: "5",
        avtar: <img src={designer} style={{ width: 50, height: 50 }} />,
        f_name: "Colton",
        l_name: "Clay",
        email: "Colton.Clay@gmail.com",
        last_login: "1 Days ago",
        role: "Customer"
    },
    {
        id: "6",
        avtar: <img src={user} style={{ width: 50, height: 50 }} />,
        f_name: "Maxine",
        l_name: "Woters",
        email: "woters.maxine@gmail.com",
        last_login: "10 Days ago",
        role: "Customer"
    },
    {
        id: "7",
        avtar: <img src={user3} style={{ width: 50, height: 50 }} />,
        f_name: "Alonzo",
        l_name: "Perez",
        email: "Perez.Alonzo@gmail.com",
        last_login: "2 Days ago",
        role: "Customer"
    },
    {
        id: "8",
        avtar: <img src={user1} style={{ width: 50, height: 50 }} />,
        f_name: "Skylar",
        l_name: "Lane",
        email: "Lane.Skylar@gmail.com",
        last_login: "1 Days ago",
        role: "Customer"
    },
    {
        id: "9",
        avtar: <img src={boy2} style={{ width: 50, height: 50 }} />,
        f_name: "Brody",
        l_name: "Gray",
        email: "Gray.Brody@gmail.com",
        last_login: "3 Days ago",
        role: "Admin"
    },
    {
        id: "10",
        avtar: <img src={designer} style={{ width: 50, height: 50 }} />,
        f_name: "Colton",
        l_name: "Clay",
        email: "Colton.Clay@gmail.com",
        last_login: "1 Days ago",
        role: "Customer"
    },
    {
        id: "11",
        avtar: <img src={user} style={{ width: 50, height: 50 }} />,
        f_name: "Maxine",
        l_name: "Woters",
        email: "woters.maxine@gmail.com",
        last_login: "10 Days ago",
        role: "Customer"
    },
    {
        id: "12",
        avtar: <img src={user3} style={{ width: 50, height: 50 }} />,
        f_name: "Alonzo",
        l_name: "Perez",
        email: "Perez.Alonzo@gmail.com",
        last_login: "2 Days ago",
        role: "Customer"
    },
    {
        id: "13",
        avtar: <img src={user1} style={{ width: 50, height: 50 }} />,
        f_name: "Skylar",
        l_name: "Lane",
        email: "Lane.Skylar@gmail.com",
        last_login: "1 Days ago",
        role: "Customer"
    },
    {
        id: "14",
        avtar: <img src={boy2} style={{ width: 50, height: 50 }} />,
        f_name: "Brody",
        l_name: "Gray",
        email: "Gray.Brody@gmail.com",
        last_login: "3 Days ago",
        role: "Admin"
    },
    {
        id: "15",
        avtar: <img src={designer} style={{ width: 50, height: 50 }} />,
        f_name: "Colton",
        l_name: "Clay",
        email: "Colton.Clay@gmail.com",
        last_login: "1 Days ago",
        role: "Customer"
    },
    {
        id: "16",
        avtar: <img src={user5} style={{ width: 50, height: 50 }} />,
        f_name: "Rowan",
        l_name: "Torres",
        email: "Rowan.torres@gmail.com",
        last_login: "6 Days ago",
        role: "Customer"
    },
    {
        id: "17",
        avtar: <img src={user3} style={{ width: 50, height: 50 }} />,
        f_name: "Alonzo",
        l_name: "Perez",
        email: "Perez.Alonzo@gmail.com",
        last_login: "2 Days ago",
        role: "Customer"
    },
    {
        id: "18",
        avtar: <img src={user1} style={{ width: 50, height: 50 }} />,
        f_name: "Skylar",
        l_name: "Lane",
        email: "Lane.Skylar@gmail.com",
        last_login: "1 Days ago",
        role: "Customer"
    },
    {
        id: "19",
        avtar: <img src={boy2} style={{ width: 50, height: 50 }} />,
        f_name: "Brody",
        l_name: "Gray",
        email: "Gray.Brody@gmail.com",
        last_login: "3 Days ago",
        role: "Admin"
    },
    {
        id: "20",
        avtar: <img src={designer} style={{ width: 50, height: 50 }} />,
        f_name: "Colton",
        l_name: "Clay",
        email: "Colton.Clay@gmail.com",
        last_login: "1 Days ago",
        role: "Customer"
    },
]
export default data